import { withState } from 'recompose';

export default withState('name', 'updateName', `Disbursement ${  Date.now()}`);
